module.exports = __webpack_public_path__ + "img/logo-short-h-white.18ccae1f.png";